import {
  Star,
  TrendUp,
  Scales,
  Gauge,
  Footprints,
  Drop,
  Bed,
  ChartBar,
  Calendar,
  Plus,
  Barbell,
  BowlFood,
} from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";

interface FeatCapp {
  logo: string;
  showLogoSkeleton?: boolean;
}

export default function FeatcalApp({
  logo,
  showLogoSkeleton = false,
}: FeatCapp) {
  return (
    <div className="flex flex-col h-full overflow-hidden cursor-default">
      {/* <div className="w-full h-[74px] z-50 bg-white"></div> */}
      <div className="w-full flex justify-between items-center z-50 h-17 px-4 bg-white border-b border-slate-300">
        <div className="">
          {showLogoSkeleton ? (
            <div className="h-6 w-32 bg-slate-200 rounded-full animate-pulse"></div>
          ) : (
            <Image
              src={logo || "/images/logo.svg"}
              alt="Logo"
              width={200}
              height={200}
              className="w-full h-5 object-contain"
            />
          )}
        </div>
        <div className="">ddd</div>
      </div>
      <div className="flex flex-col h-full w-full">
        <main className="flex-1 flex flex-col overflow-y-auto bg-slate-100  border-b border-slate-300 z-50 overscroll-none">
          <div className="flex-1 overflow-y-auto">
            <div className="bg-white border-b border-slate-300 overflow-x-auto no-scrollbar sticky top-0 z-10">
              <div className="flex min-w-max relative">
                <div className="bg-gradient-to-r from-white to-transparent -ml-8 h-16 w-16 inline-block sticky left-0 top-0 pointer-events-none"></div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">4</div>
                  <div className="text-xs text-slate-500 -mt-0.5">TUE</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">5</div>
                  <div className="text-xs text-slate-500 -mt-0.5">WED</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">6</div>
                  <div className="text-xs text-slate-500 -mt-0.5">THU</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">7</div>
                  <div className="text-xs text-slate-500 -mt-0.5">FRI</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">8</div>
                  <div className="text-xs text-slate-500 -mt-0.5">SAT</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">9</div>
                  <div className="text-xs text-slate-500 -mt-0.5">SUN</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">10</div>
                  <div className="text-xs text-slate-500 -mt-0.5">MON</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">11</div>
                  <div className="text-xs text-slate-500 -mt-0.5">TUE</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">12</div>
                  <div className="text-xs text-slate-500 -mt-0.5">WED</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">13</div>
                  <div className="text-xs text-slate-500 -mt-0.5">THU</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">14</div>
                  <div className="text-xs text-slate-500 -mt-0.5">FRI</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">15</div>
                  <div className="text-xs text-slate-500 -mt-0.5">SAT</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">16</div>
                  <div className="text-xs text-slate-500 -mt-0.5">SUN</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">17</div>
                  <div className="text-xs text-slate-500 -mt-0.5">MON</div>
                </div>
                <div className="bg-white text-slate-500 cursor-pointer hover:scale-105 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">18</div>
                  <div className="text-xs text-slate-500 -mt-0.5">TUE</div>
                </div>
                <div className="bg-blue-100 text-blue-600 w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">19</div>
                  <div className="text-xs text-blue-600 -mt-0.5">WED</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">20</div>
                  <div className="text-xs text-slate-300 -mt-0.5">THU</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">21</div>
                  <div className="text-xs text-slate-300 -mt-0.5">FRI</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">22</div>
                  <div className="text-xs text-slate-300 -mt-0.5">SAT</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">23</div>
                  <div className="text-xs text-slate-300 -mt-0.5">SUN</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">24</div>
                  <div className="text-xs text-slate-300 -mt-0.5">MON</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">25</div>
                  <div className="text-xs text-slate-300 -mt-0.5">TUE</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">26</div>
                  <div className="text-xs text-slate-300 -mt-0.5">WED</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">27</div>
                  <div className="text-xs text-slate-300 -mt-0.5">THU</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">28</div>
                  <div className="text-xs text-slate-300 -mt-0.5">FRI</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">29</div>
                  <div className="text-xs text-slate-300 -mt-0.5">SAT</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">30</div>
                  <div className="text-xs text-slate-300 -mt-0.5">SUN</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">1</div>
                  <div className="text-xs text-slate-300 -mt-0.5">MON</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">2</div>
                  <div className="text-xs text-slate-300 -mt-0.5">TUE</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">3</div>
                  <div className="text-xs text-slate-300 -mt-0.5">WED</div>
                </div>
                <div className="bg-slate-100 text-slate-300 cursor-not-allowed w-16 h-16 flex flex-col items-center justify-center transition-transform">
                  <div className="text-md font-bold">4</div>
                  <div className="text-xs text-slate-300 -mt-0.5">THU</div>
                </div>
                <div className="bg-gradient-to-l from-white to-transparent -mr-8 h-16 w-16 inline-block sticky right-0 top-0 pointer-events-none"></div>
              </div>
            </div>
            <div className="p-4 pb-0 max-w-3xl mx-auto">
              <div className="bg-white rounded-2xl cursor-pointer active:scale-[0.98] transition-all duration-200 hover:border-slate-300 overflow-hidden">
                <div className="p-6 pb-4">
                  <div className="flex items-start justify-between mb-6">
                    <div className="flex-1">
                      <div className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1">
                        Phase 1
                      </div>
                      <h3 className="text-xl font-semibold text-slate-900 mb-2">
                        Getting Started
                      </h3>
                      <div className="text-sm text-slate-500">
                        Next: Build Healthy Habits
                      </div>
                    </div>
                    <div className="flex-shrink-0 ml-4">
                      <div
                        className="relative"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <svg
                          width="80"
                          height="80"
                          className="transform -rotate-90"
                        >
                          <circle
                            cx="40"
                            cy="40"
                            r="37"
                            fill="none"
                            stroke="#e2e8f0"
                            strokeWidth="6"
                          ></circle>
                          <circle
                            cx="40"
                            cy="40"
                            r="37"
                            fill="none"
                            stroke="rgb(15 23 42)"
                            strokeWidth="6"
                            strokeDasharray="232.4778563656447"
                            strokeDashoffset="104.6150353645401"
                            strokeLinecap="round"
                            className="transition-all duration-500 ease-out"
                          ></circle>
                        </svg>
                        <div className="absolute inset-0 flex flex-col items-center justify-center">
                          <div className="text-2xl font-semibold text-slate-900 tracking-tight">
                            55%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-6 pt-4 border-t border-slate-100">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-slate-900 flex items-center justify-center">
                        <Star className="text-white" size={16} weight="fill" />
                      </div>
                      <div>
                        <div className="text-xs text-slate-500 font-medium">
                          Points
                        </div>
                        <div className="text-lg font-semibold text-slate-900">
                          275
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center">
                        <TrendUp className="text-slate-600" size={16} />
                      </div>
                      <div>
                        <div className="text-xs text-slate-500 font-medium">
                          Progress
                        </div>
                        <div className="text-lg font-semibold text-slate-900">
                          55%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 grid grid-cols-2 gap-4 max-w-3xl mx-auto">
              <div className="">
                <div className="!bg-white shadow-2xl shadow-slate-300/30 rounded-2xl border-t border-white p-4 relative overflow-hidden bg-blue-600 text-blue-600 cursor-pointer active:scale-95 transition-transform">
                  <div className="flex justify-end">
                    <div className="bg-blue-600 text-blue-600 opacity-35 blur-2xl h-12 w-12 absolute -top-3 -right-3"></div>
                    <div className="text-2xl">
                      <Scales size={24} weight="fill" />
                    </div>
                  </div>
                  <div className="text-sm text-slate-500">Weight</div>
                  <div className="flex items-end gap-1.5">
                    <div className="text-2xl text-slate-900 font-extrabold">
                      225.1
                    </div>
                    <div className="text-sm text-slate-500 mb-[3px]">lbs</div>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="!bg-white shadow-2xl shadow-slate-300/30 rounded-2xl border-t border-white p-4 relative overflow-hidden bg-yellow-600 text-yellow-600 ">
                  <div className="flex justify-end">
                    <div className="bg-yellow-600 text-yellow-600 opacity-35 blur-2xl h-12 w-12 absolute -top-3 -right-3"></div>
                    <div className="text-2xl">
                      <Gauge size={24} weight="fill" />
                    </div>
                  </div>
                  <div className="text-sm text-slate-500">BMI</div>
                  <div className="flex items-end gap-1.5">
                    <div className="text-2xl text-slate-900 font-extrabold">
                      32.6
                    </div>
                    <div className="text-sm text-slate-500 mb-[3px]"></div>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="!bg-white shadow-2xl shadow-slate-300/30 rounded-2xl border-t border-white p-4 relative overflow-hidden bg-indigo-600 text-indigo-600 cursor-pointer active:scale-95 transition-transform">
                  <div className="flex justify-end">
                    <div className="bg-indigo-600 text-indigo-600 opacity-35 blur-2xl h-12 w-12 absolute -top-3 -right-3"></div>
                    <div className="text-2xl">
                      <Footprints size={24} weight="fill" />
                    </div>
                  </div>
                  <div className="text-sm text-slate-500">Steps</div>
                  <div className="flex items-end gap-1.5">
                    <div className="text-2xl text-slate-900 font-extrabold">
                      0
                    </div>
                    <div className="text-sm text-slate-500 mb-[3px]"></div>
                  </div>
                  <div className="w-full h-2 bg-slate-200 rounded-full mt-2">
                    <div
                      className="h-full rounded-full transition-colors duration-300 bg-slate-600"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="!bg-white shadow-2xl shadow-slate-300/30 rounded-2xl border-t border-white p-4 relative overflow-hidden bg-cyan-600 text-cyan-600 cursor-pointer active:scale-95 transition-transform">
                  <div className="flex justify-end">
                    <div className="bg-cyan-600 text-cyan-600 opacity-35 blur-2xl h-12 w-12 absolute -top-3 -right-3"></div>
                    <div className="text-2xl">
                      <Drop size={24} weight="fill" />
                    </div>
                  </div>
                  <div className="text-sm text-slate-500">Hydration</div>
                  <div className="flex items-end gap-1.5">
                    <div className="text-2xl text-slate-900 font-extrabold">
                      0
                    </div>
                    <div className="text-sm text-slate-500 mb-[3px]">ml</div>
                  </div>
                  <div className="w-full h-2 bg-slate-200 rounded-full mt-2">
                    <div
                      className="h-full rounded-full transition-colors duration-300 bg-slate-600"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="col-span-2">
                <div className="!bg-white shadow-2xl shadow-slate-300/30 rounded-2xl border-t border-white p-4 relative overflow-hidden bg-red-600 text-red-600 cursor-pointer active:scale-95 transition-transform">
                  <div className="flex justify-end">
                    <div className="bg-red-600 text-red-600 opacity-35 blur-2xl h-12 w-12 absolute -top-3 -right-3"></div>
                    <div className="text-2xl">
                      <Bed size={24} weight="fill" />
                    </div>
                  </div>
                  <div className="text-sm text-slate-500">Sleep</div>
                  <div className="flex items-end gap-1.5">
                    <div className="text-2xl text-slate-900 font-extrabold">
                      0
                    </div>
                    <div className="text-sm text-slate-500 mb-[3px]">h</div>
                  </div>
                  <div className="w-full h-2 bg-slate-200 rounded-full mt-2">
                    <div
                      className="h-full rounded-full transition-colors duration-300 bg-slate-600"
                      style={{ width: "0%" }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <div className="bg-white z-0 hidden w-full justify-between items-center gap-6 transition-all duration-300 h-0 py-0 opacity-0 pointer-events-none -mt-1 blur-xl">
          <div className="bg-white border border-slate-300 rounded-xl flex-1 text-center flex flex-col items-center justify-center p-4 gap-2">
            <ChartBar
              className="bg-orange-100 text-orange-600 p-2 w-9 h-9 rounded-lg"
              size={24}
              weight="fill"
            />
            Macro Analysis
          </div>
          <div className="bg-white border border-slate-300 rounded-xl flex-1 text-center flex flex-col items-center justify-center p-4 gap-2">
            <BowlFood
              className="bg-blue-100 text-blue-600 p-2 w-9 h-9 rounded-lg"
              size={24}
              weight="fill"
            />
            Meal Plan
          </div>
        </div>
        <div className=" bg-white border-t z-10 border-slate-300 flex items-center justify-center pt-3 pwa-mobile pb-6 flex-shrink-0">
          <div className="flex justify-between gap-2 w-full px-4 items-center">
            <div className="w-16 flex justify-center">
              <div className="group flex flex-col items-center gap-0.5 hover:bg-slate-50 rounded-lg">
                <Calendar
                  className="text-2xl text-slate-400 group-hover:text-slate-900 transition-transform duration-300 !text-slate-900"
                  size={24}
                  weight="fill"
                />
                <span className="text-slate-500 group-hover:text-slate-900 text-[10px] text-slate-900">
                  My Day
                </span>
              </div>
            </div>
            <div className="w-16 flex justify-center">
              <div className="group flex flex-col items-center gap-0.5 hover:bg-slate-50 rounded-lg">
                <ChartBar
                  className="text-2xl text-slate-400 group-hover:text-slate-900 transition-transform duration-300"
                  size={24}
                />
                <span className="text-slate-500 group-hover:text-slate-900 text-[10px]">
                  Progress
                </span>
              </div>
            </div>
            <div className="w-16 flex justify-center">
              <button
                className="group flex flex-col items-center gap-0.5 bg-blue-500 p-3 w-full rounded-full shadow-[inset_7px_13px_15px_-10px_rgba(255,255,255,0.7),inset_-7px_-13px_15px_-10px_rgba(0,0,0,0.1),0px_6px_20px_0px_rgba(38,144,251,0.4)] hover:!bg-blue-600 text-blue-50"
                type="button"
              >
                <Plus
                  className="text-2xl text-slate-400 group-hover:text-slate-900 transition-transform duration-300 !text-blue-50"
                  size={24}
                />
                <span className="text-slate-500 group-hover:text-slate-900 text-[10px] hidden">
                  More
                </span>
              </button>
            </div>
            <div className="w-16 flex justify-center">
              <div className="group flex flex-col items-center gap-0.5 hover:bg-slate-50 rounded-lg">
                <Barbell
                  className="text-2xl text-slate-400 group-hover:text-slate-900 transition-transform duration-300"
                  size={24}
                />
                <span className="text-slate-500 group-hover:text-slate-900 text-[10px]">
                  Workouts
                </span>
              </div>
            </div>
            <div className="w-16 flex justify-center">
              <div className="group flex flex-col items-center gap-0.5 hover:bg-slate-50 rounded-lg">
                <BowlFood
                  className="text-2xl text-slate-400 group-hover:text-slate-900 transition-transform duration-300"
                  size={24}
                />
                <span className="text-slate-500 group-hover:text-slate-900 text-[10px]">
                  Recipes
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
